import React from "react";
import PropTypes from "prop-types";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import numeral from "numeral";

const s2ab = (s) => {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
};

const DownloadButton = ({ data, year }) => {
  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const wb = XLSX.utils.book_new();
    wb.Props = {
      Title: "Tariff survey data",
      Subject: "Tariff survey data",
      Author: "GWI WaterData",
      CreatedDate: new Date(),
    };

    wb.SheetNames.push(`${year} Data`);

    let ws_data = [];

    data.map((dataset, i) => {
      let row = [];

      if(i == 0) {
        dataset.data.map(country => row.push([country[0], Number(numeral(country[1]).format("0.00"))]));
        row.map(country => (ws_data.push(country)));
      } else {
        dataset.data.map(country => row.push(country[1]));
        row.map((val,i) => ws_data[i].push(Number(numeral(val).format("0.00"))));
      }
    });
    ws_data.forEach(row => {
      const vals = row.slice(1);
      const total = vals.reduce((a,b) => a + b, 0);
      row.push(total);
    });

    const headers = ["Country", "Water", "Wastewater", "Stormwater", "Total"];
    ws_data.unshift(headers);

    const ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets[`${year} Data`] = ws;
    const wbout = XLSX.write(wb, { bookType: "xlsx",  type: "binary" });

    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), `countries_by_combined_tariff_${year}.xlsx`);

  };

  return (
    <div className="download-data-btn-wrapper">
      <a href="#" onClick={(e) => onClick(e)} className="download-data-btn" target="_blank" rel="noreferrer noopener">
        Download data
      </a>
    </div>
  );
};

DownloadButton.propTypes = {
  data: PropTypes.array.isRequired,
  year: PropTypes.string.isRequired
};

export default DownloadButton;
